<template>
    <v-flex mb-3>
        <v-radio-group v-model="testRadio">
            <v-radio
                v-for="(item,i) in variants"
                :id="'radio'+question_number+i"
                :key='i'
                :value='i+1'
                :name="'name'+question_number"
                :class="{'test__image-radio': item.image,
                         'correct': item.selected && resultsLayout && if_correct,
                         'wrong': item.selected && resultsLayout && !if_correct}"
                :disabled="resultsLayout"
                @change="$emit('change', { $event, variant_number:i } )"
            >
                <!-- <v-flex v-if="item.image" slot="label" v-html="question_image(question_number)[i]" /> -->
                <v-flex v-if="item.image" slot="label" class="wrapper-relative">
                    <v-flex v-html="question_image(question_number)[i]" />
                    <v-tooltip v-if="resultsLayout && item.tooltip" top class="question__tooltip-image">
                        <svg v-svg
                             slot="activator"
                             symbol="tooltip"
                             size="20"
                             class="question__tooltip"
                             role="presentation"
                        />
                        <span>{{ item.tooltip }}</span>
                    </v-tooltip>
                </v-flex>
                <v-flex v-else slot="label"> {{ item.text }} </v-flex>
                <v-flex v-if="item.selected && resultsLayout && if_correct" slot="label"
                        class="question__check-wrap"
                >
                    <svg v-svg
                         symbol="ok"
                         class="question__check"
                         role="presentation"
                    />
                </v-flex>
                <v-flex v-if="item.selected && resultsLayout && !if_correct" slot="label"
                        class="question__check-wrap question__check-wrap-wrong"
                >
                    <svg v-svg
                         symbol="error"
                         class="question__check"
                         role="presentation"
                    />
                </v-flex>
            </v-radio>
        </v-radio-group>
    </v-flex>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
export default {
  props: {
    variants: {
      type   : Array,
      default: ()=> [],
    },
    name: {
      type: String,
    },
    selected_index: {
      type: Number,
    },
  },
  computed: {
    ...mapGetters('testing/questions', [
      'question_image',
      'question_number',
      'questions',
      'stats',
      'test_history',
    ]),
    ...mapGetters('testing', [
      'resultsLayout',
    ]),
    testRadio: {
      get() {
        return this.variants.findIndex((x)=> x.selected)+1 || null;
      },
      set(val) {
        return this.SET_ANSWERED({event: val, question_number: this.question_number});
      },
    },
    if_correct() {
      let question = this.test_history.find((item)=>{
        return item.question_id==this.questions[this.question_number].id;
      });
      return question.success_answer;
    },
  },
  methods: {
    ...mapMutations('testing/questions', [
      'SET_ANSWERED',
    ]),
  },

};
</script>

